<div class="startNewQuestDialog_container">
  <div class="startNewQuestDialog_badge">
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 4v5h5" />
    </svg>
  </div>
  <h2 id="start-new-quest-dialog-title" class="startNewQuestDialog_title">{{ data.title }}</h2>
  <p class="startNewQuestDialog_message" [innerHTML]="data.message"></p>
  <ul class="startNewQuestDialog_list">
    <li class="startNewQuestDialog_item startNewQuestDialog_item--kept">{{ data.keptText }}</li>
    <li class="startNewQuestDialog_item startNewQuestDialog_item--reset">{{ data.resetText }}</li>
  </ul>
  <div class="startNewQuestDialog_actions">
    <button type="button" class="startNewQuestDialog_button" (click)="onCancel()">{{ data.cancelButtonText }}</button>
    <button type="button" class="startNewQuestDialog_button startNewQuestDialog_button--confirm" (click)="onConfirm()">
      {{ data.confirmButtonText }}
    </button>
  </div>
</div>
